import { css } from "@emotion/react";
import styled from "@emotion/styled";

import { CodeBlack, Palette } from "@livechat/design-system-icons";
import {
  DesignToken,
  Heading,
  Icon,
  Modal,
  RadiusToken,
  SpacingToken,
  Tag,
  Text,
  TransitionDurationToken,
  TransitionTimingToken,
} from "@livechat/design-system-react-components";

import Flex from "components/layout/Flex";
import { withVar } from "themes/helpers";

type Props = {
  toggleEditorTypeModal(): void;
  onHTMLEditorClick(): void;
  onVisualBuilderClick(): void;
};

export const EditorTypeModal: React.FC<Props> = ({
  onVisualBuilderClick,
  toggleEditorTypeModal,
  onHTMLEditorClick,
}) => (
  <Modal
    onClose={toggleEditorTypeModal}
    heading="How would you like to create your email template?"
    css={css({ width: "800px" })}
  >
    <Flex justifyContent="space-between" gap={withVar(SpacingToken.Spacing5)}>
      <Tile data-testid="create-visual-template" onClick={onVisualBuilderClick}>
        <RecommendTag kind="black">Recommended</RecommendTag>
        <Icon source={Palette} size="xxxlarge" />
        <Heading size="sm">Use visual builder</Heading>
        <TileDescription>A visual and code-free builder</TileDescription>
      </Tile>
      <Tile data-testid="create-html-template" onClick={onHTMLEditorClick}>
        <Icon source={CodeBlack} size="xxxlarge" />
        <Heading size="sm">Use HTML editor</Heading>
        <TileDescription>An advanced coding editor</TileDescription>
      </Tile>
    </Flex>
  </Modal>
);

const Tile = styled.div`
  position: relative;
  display: flex;
  flex: 1;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: var(${SpacingToken.Spacing9}) var(${SpacingToken.Spacing5});
  gap: var(${SpacingToken.Spacing2});
  cursor: pointer;
  border-radius: var(${RadiusToken.Radius3});
  border: 1px solid var(${DesignToken.BorderBasicPrimary});
  transition: border-color var(${TransitionDurationToken.Fast2}) var(${TransitionTimingToken.EaseOut});

  &:hover {
    border-color: var(${DesignToken.BorderBasicHover});
  }
`;

const TileDescription = styled(Text)`
  color: var(${DesignToken.ContentBasicSecondary});
`;

const RecommendTag = styled(Tag)`
  position: absolute;
  top: var(${SpacingToken.Spacing3});
  right: var(${SpacingToken.Spacing3});
`;
